
import React, { useEffect, useRef, useState } from "react";
import logo from '../assets/images/logo.svg';
import TopNav from "./TopNav";
import Footer from "./Footer";
import ConfirmationDialog from "./modals/ConfirmationDialog";
import Cookies from "js-cookie";

function ProfileFirst(props) {

    const [isShowingLogoutConfirmation, setIsShowingLogoutConfirmation] = useState(false)

    return (
        <div className="pagewrapper" id="profile-page">
            {isShowingLogoutConfirmation && <ConfirmationDialog onCloseFunc={() => setIsShowingLogoutConfirmation(false)} title="خروج از حساب کاربری" message="نسبت به این اقدام اطمینان دارید؟" ok={() => {

                localStorage.clear()
                document.cookie.split(";").forEach((c) => {
                    document.cookie = c
                        .replace(/^ +/, "")
                        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                });

                window.location = './login'
                setIsShowingLogoutConfirmation(false)
            }} />}
            <div className="blur">
                <div className="container">
                    <TopNav />
                    <div className="clear" />
                    <div className="content">
                        {/* <a href title className="link-button ease box-sizing radius50">جستجوی مزارهای دیجیتال</a> */}
                        <a className="clickable" href="/add-motevafa" title className="link-button ease box-sizing radius50">ساخت صفحه یادبود</a>
                        <a className="clickable" href title onClick={() => window.location = './d-list?mine=true'} className="link-button ease box-sizing radius50">لیست صفحات یادبود من ( ویرایش )</a>
                        <a className="clickable" href="./donate" title className="link-button ease box-sizing radius50">کمک و حمایت مالی به نکویاد</a>
                        <a className="clickable" onClick={() => setIsShowingLogoutConfirmation(true)} title className="link-button blue ease box-sizing radius50">خروج از پنل کاربری</a>
                    </div>

                </div>
                <div className="clear" />
                <Footer />
            </div>
        </div>
    )
}
export default ProfileFirst